/* Dwell & Company — style family swatches
 * Card swatches: hover previews a sibling in the card (desktop), click/tap
 * selects it so it sticks; the card's image, title, price and links all
 * switch to that sibling, so clicking the card opens the listing it shows.
 * Uses document-level delegation so cards injected later (predictive search,
 * infinite scroll, filtering) work without re-init.
 */
(function () {
  if (window.__dwellSwatches) return;
  window.__dwellSwatches = true;

  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function cardOf(el) { return el.closest('.card-wrapper'); }

  function swapImage(card, token, el, src, srcset, alt) {
    if (el.getAttribute('src') === src) return;
    var pre = new Image();
    pre.sizes = el.getAttribute('sizes') || '';
    if (srcset) pre.srcset = srcset;
    pre.src = src;
    var done = function () {
      if (card.__dssToken !== token) return;
      if (srcset) el.setAttribute('srcset', srcset); else el.removeAttribute('srcset');
      el.setAttribute('src', src);
      el.setAttribute('alt', alt);
      el.removeAttribute('loading');
    };
    (pre.decode ? pre.decode() : Promise.reject()).then(done, function () { pre.complete ? done() : (pre.onload = done); });
  }

  // Warm the cache: on the first hover over a card's swatches, start loading
  // every sibling photo so later hovers swap instantly.
  function warm(row) {
    if (row.__dssWarm) return; row.__dssWarm = true;
    row.querySelectorAll('.dss__swatch').forEach(function (b) {
      ['data-dss-src', 'data-dss-src2'].forEach(function (a) { var u = b.getAttribute(a); if (u) { var i = new Image(); i.src = u; } });
    });
  }

  function apply(card, sw) {
    if (!card || !sw) return;
    var url = sw.getAttribute('data-dss-url');
    var title = sw.getAttribute('data-dss-title');

    // Photos: load the sibling's image off-screen first and only swap once it
    // has decoded, so the card never blanks while the new photo downloads.
    // A token per card drops stale loads when the pointer moves quickly.
    var img = card.querySelector('img.media--first') || card.querySelector('.card__inner img');
    var img2 = card.querySelector('img.media--second');
    var src = sw.getAttribute('data-dss-src');
    var src2 = sw.getAttribute('data-dss-src2');
    var token = (card.__dssToken = (card.__dssToken || 0) + 1);
    if (img && src) {
      swapImage(card, token, img, src, sw.getAttribute('data-dss-srcset'), sw.getAttribute('data-dss-alt') || title || '');
    }
    if (img2 && src2) {
      swapImage(card, token, img2, src2, sw.getAttribute('data-dss-srcset2'), img2.getAttribute('alt') || '');
    }
    card.classList.toggle('dss-no-second', !src2);

    var titleLink = card.querySelector('.card__title a');
    if (titleLink) {
      titleLink.textContent = title;
      titleLink.setAttribute('href', url);
      titleLink.setAttribute('title', title);
    }
    var hidden = card.querySelector(':scope > .visually-hidden');
    if (hidden) hidden.textContent = title;
    card.querySelectorAll('.card-wrapper__link--overlay').forEach(function (a) { a.setAttribute('href', url); });

    var tpl = sw.querySelector('template.dss__price');
    var price = card.querySelector('.card-information .price');
    if (tpl && price) {
      var fresh = tpl.content.firstElementChild;
      if (fresh) price.replaceWith(fresh.cloneNode(true));
    }

    card.classList.toggle('dss-swapped', sw.getAttribute('data-dss-own') !== '1');
  }

  function selected(row) {
    return row.querySelector('.dss__swatch.is-selected') || row.querySelector('.dss__swatch.is-current');
  }

  function select(sw) {
    var row = sw.closest('.dss__row');
    row.querySelectorAll('.dss__swatch').forEach(function (b) {
      var on = b === sw;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var card = cardOf(sw);
    apply(card, sw);
    restartDwell(card);
  }

  // Mobile "dwell" (assets/dw-mobile-image-swap.js) fades a card to its second
  // photo after it has been the main card on screen for a moment, and only
  // resets on scroll. After a swatch tap, hold the new main photo for a full
  // dwell, then let the fade to the second photo happen as if freshly in view.
  var DWELL_MS = 1200; // keep in step with DWELL_MS in dw-mobile-image-swap.js
  var mobileMQ = window.matchMedia && window.matchMedia('(max-width: 989px)');
  function restartDwell(card) {
    if (!card || !mobileMQ || !mobileMQ.matches) return;
    clearTimeout(card.__dssHold);
    card.classList.add('dss-dwell-hold');
    card.__dssHold = setTimeout(function () { card.classList.remove('dss-dwell-hold'); }, DWELL_MS);
  }

  // Product page: keep the scroll position when switching to a sibling, so
  // toggling between colors doesn't jump back to the top of the page.
  var SCROLL_KEY = 'dss-scroll';
  try {
    var saved = JSON.parse(sessionStorage.getItem(SCROLL_KEY) || 'null');
    sessionStorage.removeItem(SCROLL_KEY);
    if (saved && saved.path === location.pathname && Date.now() - saved.t < 15000) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      window.scrollTo(0, saved.y);
    }
  } catch (e) {}

  document.addEventListener('click', function (e) {
    var a = e.target.closest('.dss--pdp .dss__swatch, .dss--pdp .dss__size');
    if (!a) return;
    if (a.classList.contains('is-current')) { e.preventDefault(); return; }
    try {
      sessionStorage.setItem(SCROLL_KEY, JSON.stringify({ path: new URL(a.href).pathname, y: window.scrollY, t: Date.now() }));
    } catch (err) {}
  });

  // Touch devices: start loading a card's sibling photos as soon as a finger
  // lands on its swatch row, so the tapped color's photo is ready right away.
  document.addEventListener('touchstart', function (e) {
    var row = e.target.closest && e.target.closest('.dss--card .dss__row');
    if (row) warm(row);
  }, { passive: true });

  // Card: click / tap selects (never navigates)
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.dss--card .dss__swatch');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    select(sw);
  }, true);

  if (canHover) {
    // Card: hover previews
    document.addEventListener('mouseover', function (e) {
      var cardRow = e.target.closest('.dss--card');
      if (cardRow) { var c = cardOf(cardRow); if (c) c.classList.add('dss-over'); warm(cardRow); }
      var sw = e.target.closest('.dss--card .dss__swatch');
      if (sw) apply(cardOf(sw), sw);

      var pdp = e.target.closest('.dss--pdp .dss__swatch');
      if (pdp) {
        var v = pdp.closest('.dss--pdp').querySelector('.dss__label-value');
        if (v) v.textContent = pdp.getAttribute('data-dss-name');
      }
    });
    // Leaving the row reverts to whatever is selected
    document.addEventListener('mouseout', function (e) {
      var row = e.target.closest('.dss__row');
      if (!row || (e.relatedTarget && row.contains(e.relatedTarget))) return;
      if (row.closest('.dss--card')) {
        var c = cardOf(row);
        if (c) c.classList.remove('dss-over');
        var s = selected(row);
        if (s) apply(cardOf(row), s);
      } else {
        var v = row.closest('.dss--pdp').querySelector('.dss__label-value');
        if (v) v.textContent = v.getAttribute('data-dss-default');
      }
    });
  }
})();
